var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBilling = function SvgBilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.6,
    y1: 155.3,
    x2: 188.6,
    y2: 39.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 49,
    y1: 198.2,
    x2: 218,
    y2: 82.2,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M196.4,37.8c-2.6-3.1-6.2-4.9-10.2-5.3L45.4,20.8c-4-.3-7.9.9-11,3.5-3,2.6-4.9,6.2-5.3,10.2l-2.8,26.6h-11.3c-8.3,0-15,6.7-15,15v88.2c0,8.3,6.7,15,15,15h141.3c8.3,0,15-6.7,15-15v-14.3l5,.4c.4,0,.8,0,1.3,0,7.7,0,14.3-5.9,15-13.8l7.3-87.9c.3-4-.9-7.9-3.5-11h0ZM163.6,164.2c0,4-3.2,7.2-7.2,7.2H15c-4,0-7.2-3.2-7.2-7.2v-48.3h155.7v48.3ZM163.6,108.1H7.8v-16.2h155.7v16.2ZM163.6,84.1H7.8v-8c0-4,3.2-7.2,7.2-7.2h141.3c4,0,7.2,3.2,7.2,7.2v8h0ZM184.8,136c-.3,4-3.8,6.9-7.8,6.6l-5.7-.5v-66c0-8.3-6.7-15-15-15H34.2l2.8-25.8h0c.3-4,3.8-7,7.8-6.7l140.8,11.8c1.9.2,3.7,1.1,4.9,2.5,1.2,1.5,1.8,3.3,1.7,5.3l-7.3,87.9h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.7,
    y: 127.6,
    width: 45.4,
    height: 32.3,
    rx: 3.9,
    ry: 3.9
  })))));
};
export default SvgBilling;